import styled from 'styled-components';

export const FormTitle = styled.h3`
  margin: 0;
  text-align: center;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  position: absolute;
  width: 18px;
  left: 16px;
`;

export const QuestionIcon = styled(InputIcon)`
  width: 22px;
  cursor: pointer;
`;

export const CloseIcon = styled(QuestionIcon)`
  width: 14px;
  align-self: flex-end;
`;

export const SettingsTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: 'center';
`;

export const SettingsContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  height: 500px;
  margin-top: 10px;
  padding: 0px 20px 20px 20px;
  overflow-y: auto;
`;
